import * as React from 'react';
import { Link, PrimaryButton, Stack, TextField, DefaultButton } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import '../../../css/components/login.scss';
import * as Api from '../../../api/src';
import useToken from './useToken';
import styled from 'styled-components';
import ErrorMesage from '../../../control/MessageBar/Error';
import { useHistory } from 'react-router-dom';
import { loginRequest, msalConfig } from './authAzureConfig';
import { AccountInfo, PublicClientApplication } from '@azure/msal-browser';
import { LoadingAppContext } from '../../../context/loadingApp.context';
import { LocalStorageKeys } from '../../../common/constant/constantKey';
import { DialogContext } from '../../../context/dialog.context';
import { useMsal } from '@azure/msal-react';
const LoginStyle = styled.div`
  .ms-md2 {
    min-width: 250px;
    margin-bottom: 12px;
  }
`;
// Create an instance of PublicClientApplication
const msalInstance = new PublicClientApplication(msalConfig);
const TokenApi = new Api.TokenApi();
const Login = () => {
  const { t } = useTranslation();
  let routerHistory = useHistory();
  const [loginUser, SetLoginUser] = React.useState<Api.TokenRequest>({ Email: '', Password: '' });
  const [loginErrorMessage, SetLoginErrorMessage] = React.useState('');
  const [userNameErrorMessage, SetUserNameErrorMessage] = React.useState('');
  const [passwordErrorMessage, SetPasswordErrorMessage] = React.useState('');
  const { setToken, clearToken, setTokenAzure } = useToken();
  const { accounts } = useMsal();
  const { setLoadingStatus, LoadingStatus } = React.useContext(LoadingAppContext);
  const { setMsgAlertDialog, setCallBackConfirmDialog } = React.useContext(DialogContext);
  React.useEffect(() => {
    clearToken();
    //setCheckToken("");
    document.addEventListener('keydown', function (event) {
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        document.getElementById('login')?.click();
      }
    });
  }, []);
  const getAccessToken = (account: AccountInfo): string => {
    if (account) {
      let key = `${account.homeAccountId}-login.windows.net-accesstoken`;
      let keyStorages = Object.getOwnPropertyNames(localStorage);
      key = keyStorages.find((o) => o.indexOf(key) >= 0) || '';
      let data = localStorage.getItem(key);
      if (data) {
        let objToken = JSON.parse(data);
        return objToken.secret;
      }
    }
    return '';
  };
  React.useEffect(() => {
    if (accounts && accounts.length > 0 && LoadingStatus.Ishow === false) {
      setLoadingStatus({ Ishow: true, Style: null });
      let accessToken = getAccessToken(accounts[0]);
      if (!accessToken) return;
      let DeviceToken = localStorage.getItem(LocalStorageKeys.TokenFireBase);
      TokenApi.apiIdentityTokenLoginFromAzurePost({ Token: accessToken, DeviceToken: DeviceToken })
        .then((res) => {
          var data = res.data;
          if (data.Succeeded && data.Data) {
            setTokenAzure(accessToken);
            setToken(data.Data);
            //setCheckToken(data.Data.Token);
            setTimeout(() => {
              routerHistory.push('/matrix');
              setLoadingStatus({ Ishow: false, Style: null });
            }, 300);
          } else {
            if (data?.Messages) {
              let msg = '';
              if ((data?.Messages[0] || '') === 'UserNotFound') {
                msg = t('UserNotExisted');
              } else {
                msg = data?.Messages[0] || '';
              }
              setLoadingStatus({ Ishow: false, Style: null });
              setCallBackConfirmDialog({
                action: () => {
                  msalInstance.logoutRedirect();
                },
                param: null,
              } as any);
              setMsgAlertDialog(msg);
            }
          }
        })
        .catch((err) => {
          return;
        });
    }
  }, [accounts]);
  const btnlogin_click = async () => {
    if (!loginUser.Email) {
      SetUserNameErrorMessage(t('UsernameIsRequired'));
    }
    if (!loginUser.Password) {
      SetPasswordErrorMessage(t('PasswordIsRequired'));
    }
    if (!loginUser.Password || !loginUser.Email) {
      return;
    }
    loginUser.DeviceToken = localStorage.getItem(LocalStorageKeys.TokenFireBase);
    let data = (await new Api.TokenApi().apiIdentityTokenPost(loginUser)).data;
    if (data && data.Succeeded) {
      if (data.Data) {
        setToken(data.Data);
        setTokenAzure('');
        //setCheckToken(data.Data.Token);
      }
      routerHistory.push('/matrix');
    } else {
      if (!data || (data?.Messages && data?.Messages.length > 0)) {
        SetLoginErrorMessage(t('UserOrPassWordIncorrect'));
      }
    }
  };

  const btnloginAzure_click = async () => {
    msalInstance.loginRedirect(loginRequest).then(
      (data) => {},
      (err) => {
        return;
      },
    );
  };

  return (
    <LoginStyle>
      <Stack verticalAlign={'center'} className={'title'} horizontalAlign={'center'}>
        <div className="ms-md2">
          <div className="border"></div>
        </div>
        <div className="ms-md2">{'PROJECT'}</div>
        <div className="ms-md2">{'DEVELOPMENT'}</div>
        <div className="ms-md2">{'TOOL'}</div>
      </Stack>
      <Stack verticalAlign={'center'} className={'login-stackItem ms-Grid'} horizontalAlign={'center'}>
        <div className="ms-Grid-row  ms-Grid-col margin-0 ms-md2">
          <ErrorMesage
            Message={loginErrorMessage}
            onClose={() => {
              SetLoginErrorMessage('');
            }}
          />
        </div>
        <div className="ms-Grid-row ms-Grid-col ms-md2">
          <TextField
            errorMessage={userNameErrorMessage}
            label={t('Username')}
            value={loginUser.Email}
            onChange={(e, value) => {
              SetLoginUser({ ...loginUser, Email: (value || '').trim() });
              SetUserNameErrorMessage('');
            }}
          />
        </div>
        <div className="ms-Grid-row ms-Grid-col ms-md2">
          <TextField
            errorMessage={passwordErrorMessage}
            label={t('Password')}
            type="password"
            value={loginUser.Password}
            onChange={(e, value) => {
              SetLoginUser({ ...loginUser, Password: value || '' });
              SetPasswordErrorMessage('');
            }}
          />
        </div>
        <div className="ms-Grid-row ms-Grid-col ms-md2">
          <PrimaryButton text={t('Login')} id={'login'} onClick={btnlogin_click} />
        </div>
        <div className="ms-Grid-row ms-Grid-col ms-md2">
          <Link
            onClick={() => {
              routerHistory.push('/forgotpassword');
            }}
          >
            {t('ForgotYourPassword')}
          </Link>
        </div>
        <div className="ms-Grid-row ms-Grid-col ms-md2">
          <DefaultButton text={t('LoginWith')} style={{ minWidth: 150 }} onClick={btnloginAzure_click}>
            <img style={{ height: 20 }} src="/images/logo.png"></img>
          </DefaultButton>
        </div>
      </Stack>
    </LoginStyle>
  );
};
export default Login;
